import React from 'react';
import { Paper, Box, Typography, Button, IconButton, CircularProgress } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const SelectedSongSection = ({ selectedSong, handleCancel, handleSubmit, loading }) => (
  <Paper
    elevation={0}
    sx={{
      padding: 2,
      marginTop: -1,
      marginBottom: 2,
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: 2
    }}
  >
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box>
        <Typography variant="subtitle1" sx={{ color: '#b70a20', fontWeight: 'bold' }}>Canción seleccionada</Typography>
        <Typography variant="body1" sx={{ color: 'white', fontWeight: 'bold' }}>
          {selectedSong.title} <span style={{ fontWeight: 'normal', color: 'rgba(255,255,255,0.7)' }}>por</span> {selectedSong.artist.name}
        </Typography>
      </Box>
      <IconButton onClick={handleCancel} aria-label="cancel" sx={{ color: 'rgba(255,255,255,0.7)' }}>
        <CloseIcon />
      </IconButton>
    </Box>
    <Button
      fullWidth
      variant="contained"
      onClick={handleSubmit}
      sx={{
        marginTop: 2,
        background: 'linear-gradient(45deg, #b70a20, #8f0816)',
        boxShadow: '0 4px 15px rgba(183, 10, 32, 0.4)',
        color: 'white',
        '&:hover': {
          background: 'linear-gradient(45deg, #8f0816, #b70a20)',
          boxShadow: '0 10px 25px rgba(183, 10, 32, 0.5)',
        }
      }}
      disabled={loading}
    >
      {loading ? <CircularProgress size={24} color="inherit" /> : 'Solicitar canción'}
    </Button>
  </Paper>
);

export default SelectedSongSection;
